import { render, staticRenderFns } from "./wxpriceapplication.vue?vue&type=template&id=0de8cf02&scoped=true&"
import script from "./wxpriceapplication.vue?vue&type=script&lang=js&"
export * from "./wxpriceapplication.vue?vue&type=script&lang=js&"
import style0 from "./wxpriceapplication.vue?vue&type=style&index=0&id=0de8cf02&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de8cf02",
  null
  
)

export default component.exports